import styled from 'styled-components';
import Button from '../../../../common/components/Button';

export const Container = styled.div`
  width: 100%;
  padding: 100px 2%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  background-color: #407aea;
  margin-top: 60px;
  /* overflow: hidden; */

  @media (max-width: 1080px) {
    align-items: flex-end;
    flex-direction: column;
  }

  @media (max-width: 780px) {
    align-items: center;
    padding-top: 130px;
    height: 100vh;
  }

  @media (max-width: 475px) {
    height: 100%;
  }
`;

export const SubTitle = styled.span`
  color: #fff;
  font-weight: 500;
  position: absolute;
  top: -70px;
  left: 5px;

  @media (max-width: 1280px) {
    top: -5px;
  }
`;

export const Icon = styled.img``;

export const IconContainer = styled.div`
  max-width: 350px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const LimitContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 1085px) {
    flex-direction: column;
    padding: 2%;
  }
`;

export const Text = styled.p`
  color: #fff;
  margin-top: 10px;
  width: 100%;
  font-size: 18px;
  line-height: 35px;

  @media screen and (max-width: 600px) {
    width: 100%;
    font-size: 18px;
    line-height: 32px;
  }
`;

export const AboutContent = styled.div`
  max-width: 600px;
  position: relative;

  @media (max-width: 1080px) {
    align-self: flex-start;
  }

  @media (max-width: 1080px) {
    margin-bottom: 50px;
  }
`;

export const Title = styled.h1`
  color: #000;
  font-size: 44px;
  font-weight: 500;
  color: #fff;

  @media (max-width: 1420px) {
    font-size: 42px;
  }

  @media (max-width: 1080px) {
    font-size: 34px;
  }

  @media (max-width: 525px) {
    font-size: 30px;
  }
`;

export const Image = styled.img.attrs({
  src: '/images/services.png',
  alt: 'Services',
})`
  max-width: 100%;

  @media (max-width: 1440px) {
    max-width: 100%;
  }

  @media (max-width: 1085px) {
    min-width: unset;
    justify-self: flex-end;
    align-self: flex-end;
    max-width: 280px;
    padding-left: 0;
    position: relative;
    right: 0;
    top: -100px;
  }

  @media (max-width: 780px) {
    position: unset;
    width: 100%;
    justify-self: center;
    align-self: center;
    right: 0;
    margin-top: 20px;
  }

  /* @media (max-width: 620px) {
    max-width: 590px;
  }

  @media (max-width: 525px) {
    max-width: 500px;
  }

  @media (max-width: 415px) {
    max-width: 470px;
  }

  @media (max-width: 375px) {
    max-width: 430px;
  }

  @media (max-width: 330px) {
    width: 100%;
  } */
`;

export const CustomButton = styled(Button)`
  font-weight: 600;
  font-size: 16px;
`;

export const MicrosoftImage = styled.img`
  max-width: 266px;
  width: 100%;
  height: auto;
`;
